import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ConfirmationService } from 'primeng/api';

import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserStore } from '@store/user/user.store';
import { environment } from 'src/environments/environment';
import AccessLevels from '@core/utils/access-levels';

@Component({
    selector: 'app-left-nav',
    templateUrl: './left-nav.component.html',
    styleUrls: ['./left-nav.component.scss'],
    providers: [ConfirmationService],
    imports: [RouterLink, RouterLinkActive, ConfirmDialogModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class LeftNavComponent {
    private authService = inject(MsalService);
    private confirmationService = inject(ConfirmationService);

    private readonly userStore = inject(UserStore);
    theme = this.userStore.theme;
    self = this.userStore.self;
    expanded = false;

    get isOwner(): boolean {
        return AccessLevels.isOwner(this.self()!);
    }
    get isAdmin(): boolean {
        return AccessLevels.isAdmin(this.self()!);
    }

    toggleSize(): void {
        this.expanded = !this.expanded;
    }

    get isEditorEnabled(): boolean {
        return environment.editorEnabled;
    }

    get isZonesEnabled(): boolean {
        return environment.zonesEnabled;
    }

    get isAnalyticsEnabled(): boolean {
        return environment.analyticsEnabled;
    }

    get isIntelligenceEnabled(): boolean {
        return environment.intelligenceEnabled;
    }

    toggleDarkMode(): void {
        const html = document.querySelector('html');
        if (html) {
            html.classList.toggle('theme-dark');
            this.userStore.updateTheme(html.classList.contains('theme-dark') ? 'dark' : 'light');
        }
    }

    logout(): void {
        this.confirmationService.confirm({
            message: `Are you sure that you want to log out of Airia?`,
            header: 'Log Out',
            accept: () => {
                const self = this.userStore.self();
                this.userStore.setSelf(null);
                this.authService.logoutRedirect().subscribe({
                    error: (error) => {
                        this.userStore.setSelf(self);
                        console.error('Unable to sign out of Airia', error);
                    },
                });
            },
        });
    }
}
